import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { group } from 'console';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    other_header;
    api;

    constructor(private http: HttpClient) {
        this.api = environment.wsdlUrl + "apiV3";
    }



    finTablero() {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .get(this.api + "/tablero", { headers: this.other_header })
        );
    }


    getImg(url: string) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http.get(url, {
            headers: {
                'accept': 'image/webp,image/*,*/*;q=0.8'
            },
            responseType: 'arraybuffer',
        })
        );
    }



    getUsd() {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .get("https://dolarapi.com/v1/dolares/blue"));
    }

    getCategoria() {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .get(this.api + "/categoria"));
    }

    getCatalogoCustom(criteria, arrCat, page, limit, groups) {
        this.other_header = UturuncoUtils.getHeader();
        const body = { query: criteria, category: arrCat, groups: groups }
        console.log(body)
        return firstValueFrom(this.http
            .post(this.api + "/catalogoCat?page=" + page + "&limit=" + limit,
                body,
                { headers: this.other_header }));
    }

    getCatalogo(criteria, page, limit) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/catalogo?page=" + page + "&limit=" + limit,
                { query: criteria }, { headers: this.other_header })
        );
    }

    getCompras(usuario, page, limit) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/comprador?page=" + page + "&limit=" + limit,
                { query: usuario }, { headers: this.other_header })
        );
    }

    doVentaGenerate(venta, carrito, cotizacion) {
        this.other_header = UturuncoUtils.getHeader();
        const query = {
            venta: venta,
            cotizacion: cotizacion,
            carrito: carrito
        }
        console.log(query)
        return firstValueFrom(this.http
            .post(this.api + "/ventas",
                query, { headers: this.other_header })
        );
    }

    generateCheckout(ventaID, total, descripcion, cliente_nombre, cliente_email, cliente_dni) {
        this.other_header = UturuncoUtils.getHeader();
        const ref = new Date().getTime();
        const checkout = {
            id: ventaID,
            total: total,
            currency: 'ARS',
            description: descripcion,
            reference: ref,
            customer: {
                name: cliente_nombre,
                email: cliente_email,
                identification: cliente_dni
            },
            return_url: `${window.location.origin}/#/success`,
            webhook: this.api + '/webhook',
            // otros parámetros si querés
        };

        return firstValueFrom(this.http
            .post(this.api + "/unicobro", checkout, { headers: this.other_header })
        );
    }
    actualizarVenta(estado, referencia) {
        this.other_header = UturuncoUtils.getHeader();
        const checkout = {
            estado: estado,
            reference: referencia,
        };

        return firstValueFrom(this.http
            .post(this.api + "/estadoventa", checkout, { headers: this.other_header })
        );
    }

    cancelarVenta(ventaid, usuarioId) {
        this.other_header = UturuncoUtils.getHeader();
        const data = { id: ventaid, usuario: usuarioId };

        return firstValueFrom(this.http
            .post(this.api + "/cancelar", data, { headers: this.other_header })
        );
    }

}
